/** The term is a minimum duration shown in months only; billing is always monthly. */
export const formatTermMonths = (months: number): string => `${months} ${months === 1 ? 'Monat' : 'Monate'}`;
